import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import { IconProps, SvgIcon } from '../SvgIcon';

interface LogoProps extends IconProps {
  isDisabled?: boolean;
  variant?: 'default' | 'small';
}

const useStyles = makeStyles(() => ({
  default: {
    height: '24.1px',
    width: '70.95px',
  },

  small: {
    height: '18.08px',
    width: '53.21px',
  },

  disabled: {
    '& svg path': {
      filter: 'grayscale(100%) opacity(30%)',
    },
  },
}));

export function PayGreenSwile(props: LogoProps): JSX.Element {
  const classes = useStyles();
  const { isDisabled = false, variant = 'default', ...rest } = props;

  const iconStyle = clsx(
    classes.default,
    variant === 'small' && classes.small,
    isDisabled && classes.disabled,
  );

  return (
    <SvgIcon
      className={iconStyle}
      name="PayGreenSwile"
      viewBox="0 0 70.95 24.1"
      {...rest}
    >
      <path
        d="M8.70005 24.7C12.5 24.7 15.7 23 15.7 19.2C15.7 16.1 13 14.8 9.00005 14C8.80005 14 8.50005 13.9 8.20005 13.9H8.10005C6.70005 13.6 5.20005 13.2 5.20005 11.9C5.20005 10.7 6.60005 10.2 7.90005 10.2C9.70005 10.2 11.1 11 11.5 12.8L15.1 11.8C14.2 8.49995 11.3 6.99995 7.90005 6.99995C4.40005 6.99995 1.30005 8.49995 1.30005 12.1C1.30005 15.7 4.20005 16.5 7.20005 17.1H7.40005L7.70005 17.2C9.80005 17.7 11.7 18.3 11.7 19.6C11.7 21.1 10.1 21.6 8.70005 21.6C6.70005 21.6 5.20005 20.6999 4.60005 18.7999L0.800049 19.7999C1.70005 23.1999 5.30005 24.7 8.70005 24.7ZM45.1 5.29995C46.5 5.29995 47.6 4.39995 47.6 2.99995C47.6 1.69995 46.5 0.699951 45.1 0.699951C43.6 0.699951 42.6 1.69995 42.6 2.99995C42.6 4.39995 43.7 5.29995 45.1 5.29995ZM34.8 24.7C35.9 24.7 38.1 24.2999 39.1 21.2999C39.6 19.7999 39.7001 18.5 39.8 16V15.6V15.5C39.9 13.3 40.2001 11.3 41 11.3V7.29995C39.8 7.29995 37.6 7.79995 36.6 10.8C36.1 12.3 36 14.2 35.9001 16.1C35.9001 16.6 35.8 17.2999 35.8 18V18.1C35.7001 19.5 35.4001 20.7999 34.9001 20.7999C34.1001 20.7999 33.8 17.7 33.8 16.1C33.7001 14.3 33.6 12.3 33.1 10.8C32.1 7.79995 30 7.29995 28.8 7.29995C27.6 7.29995 25.5 7.79995 24.5 10.8C24 12.3 23.9 14.3 23.8 16.1C23.8 16.6 23.7001 17.2999 23.6 18V18.1C23.4 19.5 23.2001 20.7999 22.6 20.7999C21.7001 20.7999 21.4 17.4 21.3 16.1L21.2001 7.29995H17.2001V8.19995V12.8V13.1V13.4L17.3 16.1C17.364 17.8585 17.6325 19.6035 18.1 21.2999C18.9 23.5999 20.4 24.7999 22.5 24.7999C24.6 24.7999 26.3 23.5 26.9 21.2999C27.3 19.6999 27.5 17.9 27.6 16.1C27.6 15.6 27.7 14.9 27.8 14.2V14.1V14V13.9V13.8C27.9 12.5 28.2001 11.4 28.7001 11.4C29.5 11.4 29.7 14.7 29.8 16.2C29.9 18 30 19.9 30.5 21.4C31.4 24.1999 33.6 24.7 34.8 24.7ZM47.1 24.5V7.19995H43V24.5H47.1ZM55.2001 22.2C53.8 20.2 53.2001 18.5 53.2001 15.7V1.09995H49.1V15.7C49.1 19.4 49.9001 22 51.9001 24.6C51.9001 24.7 55.2001 22.2 55.2001 22.2ZM63.6 24.7C67.5 24.7 70.1 22.4 71.1 19.6L67.4 18.6C66.8 20.1 65.5001 21 63.7001 21C61.4001 21 59.4 19.2 59.3 16.5H71.7C72.2 11.3 69.2001 6.79995 63.6 6.79995C58.8 6.79995 55.3 10.4 55.3 15.7C55.2001 20.7 58.6 24.7 63.6 24.7ZM67.8 13.5H59.4001C59.8001 11.6 61.5 10.2 63.6 10.2C65.8 10.2 67.5 11.7 67.8 13.5Z"
        fill="black"
      />
    </SvgIcon>
  );
}
